import { useForm } from "react-hook-form";
import { useEffect, useState, useRef } from "react";
import { useQuery, useMutation } from "react-query";
import { toast } from "react-toastify";

// primereact
import { Button } from "primereact/button";
import { Skeleton }from "primereact/skeleton";

// components
import OwnersSelect from "../../../../components/owners/OwnersSelect";

// services
import { getOneEnterprise } from "../../../../services/Enterprise/getOneEnterprise";
import { putEnterprise } from "../../../../services/Enterprise/putEnterprise";

// utils
import { queryClient } from "../../../../utils/queryClient";

const OwnersEdit = ({ id }) => {
  const [selectedOwnersData, setSelectedOwnersData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const hasInitializedOwners = useRef(false);
  const form = useForm();

  const { data: enterpriseData, isLoading: loadingEnterprise } = useQuery({
    queryKey: [`oneEnterprise${id}`],
    queryFn: () => getOneEnterprise(id),
  });


  useEffect(() => {
    if (
      !hasInitializedOwners.current &&
      Array.isArray(enterpriseData?.owners)
    ) {
      const updatedOwners = enterpriseData.owners.map((originalOwner) => {
        const updated = selectedOwnersData.find(
          (o) => o.user_id === originalOwner.user_id
        );
        return updated || originalOwner;
      });
      hasInitializedOwners.current = true;
    }

  }, [enterpriseData]);

  const { mutateAsync: putEnterpriseFn } = useMutation({
    mutationFn: putEnterprise,
    onSuccess(_, variables) {
      queryClient.setQueryData([`oneEnterprise${id}`], (data) => {
        data.owners = variables.owners;
        return data;
      });
    },
    onError(error) {
      console.error("erro:", error);
    },
  });

  const handleSubmit = async (updatedOwners) => {
    setIsLoading(true);
    const notification = toast.loading("Por favor aguarde...");

    const {
      owners: _owners,
      index: _index,
      updated_at: _updatedAt,
      created_at: _createdAt,
      logo: _logo,
      id: _id,
      ...enterpriseDataTreated } = enterpriseData || {};

    const sendData = {
      ...enterpriseDataTreated,
      enterprise_id: id,
      owners: updatedOwners.ownerFields,
      index_id: enterpriseData?.index?.id,
    };

    try {
      await putEnterpriseFn(sendData);
      toast.update(notification, {
        render: "Proprietário(s) atualizado com sucesso!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
    } catch (error) {
      toast.update(notification, {
        render: "Erro ao atualizar proprietário(s)!",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
    {loadingEnterprise ? (
        <div className="row ">
          <div className="col-md-4 mt-3"> <Skeleton width="25rem" height="3rem" /> </div>
          <div className="col-md-4 mt-3"> <Skeleton width="25rem" height="3rem" /> </div>
          <div className="col-md-4 mt-3"> <Skeleton width="20rem" height="3rem" /> </div>
        </div>
    ) : (
    <form>
      <div className="row">
             <div className="col-md-12">
               {form && (
                 <OwnersSelect
                   formEdit={form}
                   ownersData={enterpriseData?.owners || []}
                  />
               )}
             </div>
        <hr className="my-4" />
        <div className="col-md-12 text-end">
          <Button
            rounded
            type="submit"
            label={isLoading ? "Editando..." : "Editar"}
            iconPos="right"
            className="p-inputtext-sm m-auto"
            icon={isLoading ? "pi pi-spin pi-spinner" : "fa-solid fa-circle-chevron-right"}
            onClick={form.handleSubmit(handleSubmit)}
            disabled={isLoading}

          />
        </div>
      </div>
    </form>
    )
}
      </>
  );
};

export default OwnersEdit;
